import { ApolloCache, InMemoryCache, NormalizedCacheObject } from '@apollo/client/cache';
import { ApolloLink, concat, ApolloProvider } from '@apollo/client';
import * as React from 'react';

import { _authLink, _client, _httpLink, _retryLink } from './helpers/apollo.helper';

const { REACT_APP_DASHBOARD_ACCESS_TOKEN, REACT_APP_DASHBOARD_GRAPHQL_API_HOST } = process.env;

const cache: ApolloCache<NormalizedCacheObject> = new InMemoryCache();
const link: ApolloLink = _authLink(`${REACT_APP_DASHBOARD_ACCESS_TOKEN}`).concat(
  concat(_retryLink(), _httpLink(`${REACT_APP_DASHBOARD_GRAPHQL_API_HOST}`))
);

export const withAfbApollo = (BaseComponent: React.ComponentClass<any>) => {
  return class extends React.Component {
    render() {
      return (
        <ApolloProvider client={_client(cache, link)}>
          <BaseComponent {...this.props} />
        </ApolloProvider>
      );
    }
  };
};

export default withAfbApollo;



// WEBPACK FOOTER //
// ./src/app/afb-graphql-api/withAfbApollo.tsx